import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "../../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../../Components/Common/Dialog/DialogComponents";
import { makeStyles, styled } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
          fontSize: "18px !important",
        },
      },
    },
  },
  dialogActionBtn: {
    // marginBottom: "20px",
    paddingTop: "20px !important",
    paddingBottom: "20px !important",
  },
  reUrgencyIcon: {
    "&>div": {
      background: "rgba(90, 104, 114, 0.1)",
      border: "2px solid rgba(90, 104, 114, 0.7)",
      borderRadius: "68px",
      padding: "20px",
    },
    "&>svg": {
      color: "rgba(90, 104, 114, 0.1)",
    },
  },
  rsTitle: {
    "&>h3": {
      textAlign: "center",
      fontSize: "25px !important",
      fontWeight: "500  !important",
      color: "black",
      width: "100%",
    },
  },
  video: {
    width: "100%",
    height: "645px !important",

    [theme.breakpoints.down("1400")]: {
      height: "450px",
    },
  },
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      top: "0 !important",
      height: "860px !important",
      [theme.breakpoints.down("1500")]: {
        maxWidth: "80% !important",
      },
      [theme.breakpoints.down("1400")]: {
        maxWidth: "70% !important",
      },
      [theme.breakpoints.down("700")]: {
        maxWidth: "100% !important",
      },
    },
  },
}));

const InvoiceDailoag = (props) => {
  const classes = useStyle();
  const { open, setOpen, link, title } = props;
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [open]);
  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.rsDialogMainRoot}
        // className="RSxs_modal"
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} title={title} />
        {/* <DialogTitle className={classes.rsTitle}>
            <Typography variant="h3">{title}</Typography>
          </DialogTitle> */}
        <Box className={classes.resConfirmationBox}>
          <DialogContent style={{ justifyContent: "center", display: "flex" }}>
            {loading && <CircularProgress />}
            {!loading && (
              <iframe
                className={classes.video}
                //   width="860"
                //   height="415"
                src={`${link}`}
                title={title}
                // loading="lazy"
                allow="autoplay; fullscreen"
                frameborder="0"
                allowfullscreen
              ></iframe>
            )}
          </DialogContent>
        </Box>
        <DialogActions className={classes.dialogActionBtn}>
          <Button variant="outlined" onClick={handleClose} className="BtnGray">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDailoag);
